import React from "react";

const STAGES = [
  {
    n: "01",
    title: "Work is fragmented",
    body:
      "People, partners, systems and AI each hold part of the evidence or responsibility. Decisions become stuck in email, spreadsheets, meetings and informal escalation.",
  },
  {
    n: "02",
    title: "KATLAS coordinates the decision",
    body:
      "KATLAS connects the participants, controls who may take the next action and allows the necessary evidence to be checked without gathering everyone's data into one central system.",
  },
  {
    n: "03",
    title: "The outcome is provable",
    body:
      "The decision moves forward, sensitive information remains controlled and an auditable record shows what was requested, approved, refused, handed over or escalated.",
  },
];

export const PlatformOverview = () => {
  return (
    <section
      id="platform-overview"
      data-testid="section-platform-overview"
      className="relative py-20 lg:py-24 border-t border-white/[0.06] bg-[#020B14]"
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-10">
          <div className="mono text-[10px] uppercase tracking-[0.3em] text-[#0066FF]">
            What KATLAS does
          </div>
          <h2
            data-testid="platform-overview-headline"
            className="font-display text-3xl sm:text-4xl lg:text-[44px] mt-4 leading-[1.08]"
          >
            The controlled layer between a request{" "}
            <span className="text-slate-400">and a provable outcome.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/[0.06] border border-white/[0.06]">
          {STAGES.map((s, i) => (
            <article
              key={s.n}
              data-testid={`platform-overview-stage-${s.n}`}
              className="bg-[#040F1B] p-6 lg:p-7 flex flex-col"
            >
              <div className="flex items-baseline gap-3">
                <span
                  className={`font-display text-4xl leading-none ${
                    i === STAGES.length - 1
                      ? "text-[#EAB308]"
                      : "text-[#0066FF]"
                  }`}
                >
                  {s.n}
                </span>
                <span className="mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
                  Stage
                </span>
              </div>
              <h3 className="mt-5 font-display text-lg text-white leading-snug">
                {s.title}
              </h3>
              <p className="mt-3 text-sm sm:text-[15px] text-slate-300 leading-relaxed">
                {s.body}
              </p>
            </article>
          ))}
        </div>

        <div
          data-testid="platform-overview-flow"
          className="mt-8 flex flex-wrap items-center gap-x-3 gap-y-2 text-[11px] mono uppercase tracking-[0.22em] text-slate-400"
        >
          <span>People + partners + existing systems + AI</span>
          <span className="text-[#0066FF]" aria-hidden>→</span>
          <span className="text-white">KATLAS</span>
          <span className="text-[#0066FF]" aria-hidden>→</span>
          <span className="text-[#EAB308]">
            authorised action + auditable outcome
          </span>
        </div>
      </div>
    </section>
  );
};
